import type { UserRole } from '@types';

export const USER_ROLES: UserRole[] = ['owner', 'admin', 'editor', 'viewer', 'consultant', 'trainer', 'employee', 'service_requester', 'learner'];
export const USER_STATUSES = ['active', 'pending', 'suspended', 'pending_approval'] as const;

export const USER_ROLE_LABELS: Record<UserRole, string> = {
    owner: 'Organization Owner',
    admin: 'Organization Administrator',
    editor: 'Content Editor',
    viewer: 'Viewer',
    consultant: 'Consultant',
    trainer: 'Trainer',
    employee: 'Employee',
    service_requester: 'Service Requester',
    service_requestor: 'Service Requester',
    learner: 'Learner',
};

export const USER_STATUS_LABELS: Record<typeof USER_STATUSES[number], string> = {
    active: 'Active',
    pending: 'Invitation Pending',
    suspended: 'Suspended',
    pending_approval: 'Awaiting Approval',
};

export const getUserRoleLabel = (role: unknown) => USER_ROLE_LABELS[role as UserRole] || String(role || '');
export const getUserStatusLabel = (status: unknown) => USER_STATUS_LABELS[status as typeof USER_STATUSES[number]] || String(status || '');
